

exports.__esModule = true;
exports.$SepaPageRoute = undefined;

require('./directive');

require('components/xo-wallet-components/src/member-sepa/route');

var _squid = require('squid');

var $SepaPageRoute = exports.$SepaPageRoute = _squid.$ComponentRoute.extend('$SepaPageRoute', {

    path: 'sepapage',
    directive: 'xo-sepa-page',
    titleContent: 'DEMemberGuest.sepaTitle',
    query: ['message'],
    trackingData: {
        fptiState: 'membersepa',
        templateName: 'membersepa.dust',
        pageGoal: 'SEPA Review'
    },
    children: [{
        name: '$MemberSepaRoute',
        attributes: {
            token: 'token',
            'parent-callbacks': 'callbacks'
        }
    }]
});

angular.value("$SepaPageRoute", $SepaPageRoute);
_squid.$ComponentRoute;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-sepa/route.js
 ** module id = 420
 ** module chunks = 1
 **/